module.exports = __webpack_public_path__ + "static/media/pil_box_preloader.308b6da9.gif";